import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="mall, store, shop, business"><path d="M12 10.75V19.25" stroke="currentColor" strokeWidth="1.5"/><path d="M21.25 4.75H2.75V19.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M7.75 19.25V10.75H16.25V19.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMall;
